
import React, { useState, KeyboardEvent as ReactKeyboardEvent, useEffect, Component } from 'react';
import { Container, Switch, Grid, TextField, Typography, Box, IconButton, styled, InputAdornment, Paper, Link, Fab, Drawer, List, ListItem, ListItemIcon, ListItemButton, useMediaQuery, useTheme, CircularProgress } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SendIcon from '@mui/icons-material/Send';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ChatIcon from '@mui/icons-material/Chat';
import axios from 'axios';
import { SideMenuToggleMovil } from './sideBarMovil';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close'
import HomeIcon from '@mui/icons-material/Home'
import SettingsIcon from '@mui/icons-material/Settings'
import PersonIcon from '@mui/icons-material/Person'
import SearchIcon from '@mui/icons-material/Search'
import { motion, AnimatePresence } from 'framer-motion'
import { SideMenuToggle } from './sideBar';
import image from "../../assets/images"
import { useNavigate } from "react-router-dom";
import '@fontsource/poppins';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import {
    Camera as CameraIcon,
    Checkroom as ShirtIcon,
    ExitToApp as LogoutIcon,
    Language as LanguageIcon
} from '@mui/icons-material';
import { Console } from 'console';
import ExpandingGrid from './juegosComponent';
import LiteGraphComponent from './LiteGraph';


export const ChatPage: React.FC<{}> = () => {
    // Crea un tema personalizado
    const themes = createTheme({
        typography: {
            fontFamily: 'poppins', // Cambia por la fuente que prefieras
        },
    });

    const nav = useNavigate();
    const navigate = useNavigate();
    const [messages, setMessages] = useState<{ text: string, sender: string }[]>([]);
    const [input, setInput] = useState("");
    const [isLoad, setLoad] = useState(false);
    const [chatHistory, setChatHistory] = useState<{ chat_id: string, title: string, messages: string[] }[]>([]);
    const [selectedChat, setSelectedChat] = useState<{ chat_id: string, messages: string[] } | null>(null);

    const [isExpanded, setIsExpanded] = useState(true);
    const [isSideMenuOpen, setIsSideMenuOpen] = useState(false)
    const [isHistoryMenuOpen, setIsHistoryMenuOpen] = useState(false)

    const [isImageMovileOpen, setisImageMovileOpen] = useState(false)
    const [isSwitched, setIsSwitched] = useState(false);
    //Graficos

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsSwitched(event.target.checked)
    }


    interface Message {
        text: string;
        sender: 'user' | 'bot';
    }

    interface Chat {
        chat_id: string;
        messages: Message[];
    }

    const handleSendMessage = async () => {
        if (input.trim() === "") return;

        const chatId = selectedChat?.chat_id || "";
        const userId = localStorage.getItem("userId");

        // Añadir el mensaje del usuario
        setMessages(prevMessages => [...prevMessages, { text: input, sender: "user" }]);

        try {
            console.log("Enviando mensaje. Chat ID:", chatId, "User ID:", userId);
            setLoad(true);

            const response = await axios.post('http://localhost:5001/clasificar', {
                consulta: input,
                chat_id: chatId,
                user_id: userId
            });

            console.log("Respuesta del servidor:", response.data);

            // Procesar la respuesta
            if (response.data.error) {
                console.error('Error del servidor:', response.data.error);
                setMessages(prevMessages => [...prevMessages, {
                    text: `Error: ${response.data.error}`,
                    sender: "bot"
                }]);
            } else {
                let botMessage = "";

                if (response.data.respuesta_general) {
                    botMessage = response.data.respuesta_general;
                } else if (response.data.form_link && response.data.edit_link) {
                    botMessage = `Formulario creado. Link para ver: ${response.data.form_link} Link para editar: ${response.data.edit_link}`;
                } else if (response.data.ruta_archivo) {
                    botMessage = `Archivo creado. Ruta: ${response.data.ruta_archivo}`;
                } else {
                    botMessage = response.data.mensaje || "Respuesta recibida sin contenido específico.";
                }

                setMessages(prevMessages => [...prevMessages, { text: botMessage, sender: "bot" }]);

                // Actualizar el chat_id si es nuevo
                if (response.data.chat_id && (!selectedChat || selectedChat.chat_id !== response.data.chat_id)) {
                    setSelectedChat(prevChat => {
                        if (prevChat) {
                            return { ...prevChat, chat_id: response.data.chat_id };
                        } else {
                            return { chat_id: response.data.chat_id, messages: [] };
                        }
                    });
                }
            }

            setLoad(false);
        } catch (error) {
            setLoad(false);
            console.error('Error al enviar el mensaje:', error);
            setMessages(prevMessages => [...prevMessages, {
                text: "Error al procesar la solicitud. Por favor, intenta de nuevo.",
                sender: "bot"
            }]);
        }

        setInput(""); // Limpiar el input después de enviar
    };


    const handleChatClick = (chat?: { chat_id: string, messages: string[] }) => {
        console.log("no hace nada", chat);

        if (chat && chat.chat_id) {
            console.log("Chat seleccionado:", chat.chat_id); // Mostrar el ID del chat en consola

            // Guardar el ID del chat actual en localStorage
            localStorage.setItem("selectedChatId", chat.chat_id);

            // Actualizar el chat seleccionado en el estado
            setSelectedChat(chat);

            // Colocar los mensajes del chat seleccionado en `messages`
            if (chat.messages && chat.messages.length > 0) {
                setMessages(chat.messages.map(msg => ({
                    text: msg.replace('Usuario:', '').replace('IA:', '').trim(),
                    sender: msg.startsWith('Usuario:') ? 'user' : 'bot'
                })));
            } else {
                // Si el chat no tiene mensajes, limpiar `messages`
                setMessages([]);
            }
        } else {
            // Si no se envía un chat válido, borrar el ID del chat del localStorage
            localStorage.removeItem("selectedChatId");

            // También puedes limpiar el estado de chat seleccionado si es necesario
            setSelectedChat(null); // Asumiendo que el estado de selectedChat puede ser nulo

            // Limpiar los mensajes si no hay un chat seleccionado
            setMessages([]);
        }
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleUploadFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const formData = new FormData();
            formData.append('file', file);

            try {
                const response = await axios.post('http://localhost:5001/api/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                const botMessage = response.data.message;
                setMessages(prevMessages => [...prevMessages, { text: botMessage, sender: "bot" }]);
            } catch (error) {
                console.error('Error al subir el archivo:', error);
            }
        }
    };



    const renderMessageText = (text: string) => {

        // Patrón para detectar enlaces HTTP/HTTPS
        const urlPattern = /(https?:\/\/[^\s]+)/g;
        // Patrón para detectar rutas de archivos en Windows (ajustado para backslashes)
        const filePathPattern = /[a-zA-Z]:[\\\/](?:[^\\\/:*?"<>|\r\n]+[\\\/])*[^\\\/:*?"<>|\r\n]+/g;

        // Reemplaza las URLs por enlaces clicables y las rutas de archivos por enlaces de descarga
        const formattedText = text.replace(urlPattern, (url) =>
            `<a href="${url}" style="color: blue;" target="_blank" rel="noopener noreferrer">aquí</a>`
        ).replace(filePathPattern, (filePath) =>
            `<a href="file://${filePath}" style="color: blue;" download>descargar</a>`
        );

        // Renderiza el texto formateado como HTML
        return <Typography dangerouslySetInnerHTML={{ __html: formattedText }} />;
    };

    const fetchChatHistory = async () => {
        try {
            const userId = localStorage.getItem("userId"); // Obtener el userId desde localStorage
            if (!userId) {
                console.error("No se encontró el ID de usuario en localStorage.");
                return;
            }

            const response = await axios.get(`http://localhost:5001/api/chat/history`, {
                params: {
                    user_id: userId  // Mandar el ID de usuario como parámetro
                }
            });

            const data = response.data;

            // Verificar que data no sea null o undefined
            if (!data || data.chats.length === 0) {
                console.warn("No se encontraron chats para este usuario.");
                return;
            }

            // Verificar que los chats existan en la respuesta
            const formattedChats = data.chats.map((chat: any) => ({
                chat_id: chat.chat_id,
                messages: chat.messages,  // Obtener todos los mensajes
                title: chat.messages.length > 0 ? chat.messages[0] : "Sin mensajes", // Manejar caso donde no haya mensajes
                created_at: chat.created_at, // Incluir la fecha de creación si es necesario
                updated_at: chat.updated_at  // Incluir la fecha de actualización si es necesario
            }));

            console.log("Historial de Chats:", formattedChats);
            setChatHistory(formattedChats);
        } catch (error) {
            console.error("Error al obtener el historial de chats:", error);
        }
    };



    // useEffect para redirigir si no hay token
    useEffect(() => {
        const token = localStorage.getItem("userId");
        if (!token) {
            // No hay sesión activa, redirigir al login
            nav("/");
        } else {
            fetchChatHistory(); // Cargar historial de chats si el usuario está autenticado
        }
    }, [nav]);

    const loadSelectedChatFromLocalStorage = () => {
        // Recuperar el chat_id del localStorage
        const chatId = localStorage.getItem("selectedChatId");

        // Verificar si el chat_id existe en localStorage
        if (!chatId) {
            console.warn("No se encontró ningún chat seleccionado en localStorage.");
            return;
        }

        // Buscar el chat correspondiente en el historial de chats
        const chat = chatHistory.find(c => c.chat_id === chatId);
        console.log("Chat encontrado en localStorage:", chat);

        // Verificar si se encontró el chat
        if (!chat) {
            console.warn(`No se encontró ningún chat con el ID: ${chatId}`);
            return;
        }

        // Establecer el chat seleccionado
        setSelectedChat(chat);
        console.log("Chat seleccionado2:", chat);

        // Guardar los mensajes del chat seleccionado en el estado `messages`, limpiando los prefijos si es necesario
        if (chat.messages && chat.messages.length > 0) {
            const cleanedMessages = chat.messages.map(msg => ({
                text: msg.replace('Usuario:', '').replace('IA:', '').trim(), // Limpiar los prefijos
                sender: msg.startsWith('Usuario:') ? 'user' : 'bot' // Identificar el remitente
            }));

            // Actualizar el estado de `messages` con los mensajes limpiados
            setMessages(cleanedMessages);
        } else {
            setMessages([]); // Si no hay mensajes, asegurarse de limpiar el estado de `messages`
        }

        // Si quieres mostrar mensajes en consola
        console.log("Mensajes cargados desde localStorage:", chat.messages);
    };


    // Llamar a la función cuando la página cargue o cuando sea necesario
    useEffect(() => {
        loadSelectedChatFromLocalStorage();
    }, [chatHistory]); // Dependiendo del historial de chats



    const handleKeyPress = (event: ReactKeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            handleSendMessage();
        }
    };

    const toggleChatExpansion = () => {
        setIsExpanded(!isExpanded);
    };

    const toggleSideMenu = () => {
        setIsSideMenuOpen(!isSideMenuOpen)
        if (isHistoryMenuOpen) setIsHistoryMenuOpen(false)
    }

    const toggleHistoryMenu = () => {
        setIsHistoryMenuOpen(!isHistoryMenuOpen)
        if (isSideMenuOpen) setIsSideMenuOpen(false)
    }
    const toggleImageMovileExpansion = () => {
        setisImageMovileOpen(!isImageMovileOpen)
        if (isImageMovileOpen) setisImageMovileOpen(false)
    }


    const chatVariants = {
        expanded: {
            width: '100%',
        },
        collapsed: {
            width: '40%',
        }
    }


    const containerVariants = {
        expanded: { width: '100%' },
        collapsed: { width: '40%' }
    };

    const imageContainerVariants = {
        expanded: { width: '0%', opacity: 0 },
        collapsed: { width: '60%', opacity: 1 }
    };

    const imageContainerVariantsMovile = {
        initial: {
            y: 100,
            opacity: 0,
        },
        activated: {
            y: 0,
            opacity: 1,
        },
    }

    const transition = {
        type: "spring",
        stiffness: 100,
        damping: 20,
        mass: 1.5
    };

    const messageVariants = {
        initial: { opacity: 0, y: 50 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -50 }
    };
    const menuVariants = {
        open: { x: 0, opacity: 1 },
        closed: { x: "-100%", opacity: 0 }
    }

    const isImageMovileVariants = {
        initial: {
            y: -17,
            x: -19, // Mantiene la posición inicial
        },
        activated: {
            y: -235,
            x: -19,  // Sube 50px en el eje Y
        },
    }


    const menuItems = [
        { icon: image.settings, fallbackIcon: <SettingsIcon />, label: 'Settings', url: '/settings' },
        { icon: image.user, fallbackIcon: <PersonIcon />, label: 'Profile', url: '/profile' },
        { icon: image.camara, fallbackIcon: <CameraIcon />, label: 'Camera', url: '/camera' },
        { icon: image.shop, fallbackIcon: <CameraIcon />, label: 'Shop', url: '/shop' },
        { icon: image.key, fallbackIcon: <CameraIcon />, label: 'Key', url: '/key' },
        { icon: image.shirt, fallbackIcon: <ShirtIcon />, label: 'Clothing', url: '/clothing' },
        { icon: image.chat, fallbackIcon: <ChatIcon />, label: 'Chat', url: '/chat' },
        { icon: image.catalogo, fallbackIcon: <SearchIcon />, label: 'Search', url: '/search' },
    ];

    const menuItemsMovile = [
        { icon: image.settings, fallbackIcon: <SettingsIcon />, label: 'Settings', url: '/settings' },
        { icon: image.chat, fallbackIcon: <ChatIcon />, label: 'Chat', url: '/chat' },
        { icon: image.key, fallbackIcon: <CameraIcon />, label: 'Key', url: '/key' },
    ];

    // const menuItems = [
    //     { icon: <SettingsIcon />, label: 'Settings' },
    //     { icon: <PersonIcon />, label: 'Profile' },
    //     { icon: <CameraIcon />, label: 'Camera' },
    //     { icon: <ShirtIcon />, label: 'Clothing' },
    //     { icon: <ChatIcon />, label: 'Chat' },
    //     { icon: <SearchIcon />, label: 'Search' },
    // ];

    const fabVariants = {
        initial: { x: 0 },
        activated: { x: 100 },
    };

    const fabVariantsMovile = {
        initial: { y: 0, opacity: 1 }, // Empieza en la posición inicial y oculto
        activated: { y: -125, opacity: 1 }, // Se mueve hacia arriba y aparece
        exit: { y: -125, opacity: 0 }, // Vuelve a la posición inicial y se oculta
    };

    const ZoomIconWrapper = styled(Box)(({ theme }) => ({
        transition: theme.transitions.create(['transform', 'box-shadow'], {
            duration: theme.transitions.duration.shorter,
        }),
        '&:hover': {
            transform: 'scale(1.2)',
            boxShadow: theme.shadows[4],
        },
    }));


    useEffect(() => {
        fetchChatHistory();
    }, []);
    return (
        <ThemeProvider theme={themes}>
            <CssBaseline />
            <Box className="min-h-screen bg-gradient-to-br from-purple-600 via-pink-500 to-yellow-500 flex items-center justify-center p-10 overflow-hidden	" >
                <Container maxWidth={false} sx={{
                    bgcolor: 'white',
                    borderRadius: 2,
                    overflow: 'visible',
                    boxShadow: 3,
                    width: '100vw',
                    height: '90vh',
                    display: 'flex',
                    position: 'relative',
                    padding: '0 !important',
                }}>
                    <motion.div
                        initial="closed"
                        animate={isSideMenuOpen ? "open" : "closed"}
                        variants={menuVariants}
                        transition={{ type: "spring", stiffness: 100, damping: 20 }}
                        style={{
                            position: 'absolute',
                            left: 0,
                            bottom: isMobile ? 0 : 'auto', // Para móviles, el menú está en la parte inferior
                            top: isMobile ? 'auto' : 0, // Para móviles, no está pegado arriba
                            right: isMobile ? 0 : 'auto', // Ocupa todo el ancho en móviles
                            width: isMobile ? '100%' : '100px', // En móviles, ocupa el ancho completo
                            height: isMobile ? '80px' : '100%', // Definimos una altura fija para móviles
                            backgroundColor: '#f0f0f0',
                            zIndex: 10,
                            padding: isMobile ? '10px' : '20px', // Espaciado reducido para móviles
                            borderRadius: isMobile ? '0' : '10px', // Sin bordes redondeados en móviles
                            boxShadow: isMobile ? '0px -2px 5px rgba(0,0,0,0.1)' : '2px 0 5px rgba(0,0,0,0.1)', // Sombra ajustada en móviles
                        }}
                    >
                        <Box
                            sx={{
                                overflow: 'auto',
                                height: isMobile ? '100%' : '100%',
                                display: 'flex',
                                flexDirection: isMobile ? 'row' : 'column', // Para móviles, los íconos se alinean en fila
                                justifyContent: isMobile ? 'space-between' : 'flex-start', // Centrado en móviles
                                alignItems: 'center', // Alineado en el centro en ambos casos
                            }}
                        >
                            <Box sx={{ p: isMobile ? 0 : 1, mb: isMobile ? 0 : 2 }}>
                                <Box
                                    sx={{
                                        width: isMobile ? 40 : 50, // Tamaño del logo ajustado para móviles
                                        height: 0,
                                        borderRadius: '12px',
                                        bgcolor: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: 'bold',
                                        color: 'text.primary',
                                    }}
                                >
                                    <img
                                        src={image.berusLogo}
                                        alt="Berus Logo"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </Box>
                                <ZoomIconWrapper>
                                    <ListItemButton
                                        onClick={() => navigate("/dash")}
                                        sx={{
                                            minHeight: isMobile ? 40 : 48,
                                            justifyContent: 'center',
                                            px: 2.5,
                                            borderRadius: '50%',
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                minWidth: 0,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <HomeIcon />
                                        </ListItemIcon>
                                    </ListItemButton>
                                </ZoomIconWrapper>
                            </Box>
                            <List
                                sx={{
                                    display: 'flex',
                                    flexDirection: isMobile ? 'row' : 'column',
                                }}
                            >
                                {(isMobile ? menuItemsMovile : menuItems).map((item, index) => (
                                    <ListItem key={index} disablePadding sx={{}}>
                                        <ZoomIconWrapper>
                                            <ListItemButton
                                                onClick={() => navigate(item.url)}
                                                sx={{
                                                    top: 0,
                                                    minHeight: isMobile ? 40 : 60,

                                                    px: 2.5,
                                                    alignItems: 'center',
                                                    height: '10%',
                                                }}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: '10%',
                                                        mr: 'auto',
                                                        justifyContent: 'space-between',
                                                        flexDirection: isMobile ? 'row' : 'column',
                                                        display: isMobile ? 'flex' : 'flex',
                                                    }}
                                                >
                                                    {item.icon ? (
                                                        <img src={item.icon} alt={item.label} style={{ width: 24, height: 24 }} />
                                                    ) : (
                                                        item.fallbackIcon
                                                    )}
                                                </ListItemIcon>
                                            </ListItemButton>
                                        </ZoomIconWrapper>
                                    </ListItem>
                                ))}
                            </List>
                            <Box sx={{ mt: 'auto' }}>
                                <List sx={{
                                    display: 'flex',
                                    flexDirection: isMobile ? 'row' : 'column',
                                }}>
                                    {[{ icon: <LanguageIcon />, label: 'Language' }, { icon: <LogoutIcon />, label: 'Logout' }].map((item, index) => (
                                        <ListItem key={index} disablePadding sx={{ display: 'block' }}>

                                            <ZoomIconWrapper>
                                                <ListItemButton
                                                    sx={{
                                                        minHeight: isMobile ? 40 : 48,
                                                        justifyContent: 'center',
                                                        px: 0.5,
                                                    }}
                                                >
                                                    <ListItemIcon
                                                        sx={{
                                                            minWidth: 0,
                                                            mr: '0',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        {item.icon}
                                                    </ListItemIcon>
                                                </ListItemButton>
                                            </ZoomIconWrapper>
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                        </Box>
                    </motion.div>


                    <motion.div
                        initial="closed"
                        animate={isHistoryMenuOpen ? "open" : "closed"}
                        variants={menuVariants}
                        transition={{ type: "spring", stiffness: 100, damping: 20 }}
                        style={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            bottom: 0,
                            width: '200px',
                            backgroundColor: '#f0f0f0',
                            zIndex: 10,
                            padding: '20px',
                            borderRadius: 10,
                            boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
                            overflowX: 'hidden',
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Typography variant="h6">Historial de chats</Typography>
                            <IconButton onClick={toggleHistoryMenu} size="small">
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        {/* Lista dinámica de historial de chats */}
                        <Box component="ul" sx={{ listStyle: 'none', padding: 0 }}>
                            {chatHistory.length > 0 ? (
                                chatHistory.map((chat) => (
                                    <Box
                                        key={chat.chat_id}
                                        component="li"
                                        sx={{
                                            mb: 1,
                                            padding: '10px',
                                            backgroundColor: '#e0e0e0',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#d0d0d0',
                                            },
                                        }}
                                        onClick={() => handleChatClick(chat)} // Al hacer clic, seleccionamos el chat
                                    >
                                        <Typography variant="body2">
                                            {chat.title} {/* Mostramos el primer mensaje como título */}
                                        </Typography>
                                    </Box>
                                ))
                            ) : (
                                <Typography variant="body2">No hay chats disponibles</Typography>
                            )}

                            {/* Botón para iniciar un nuevo chat */}
                            <Box
                                component="li"
                                sx={{
                                    mt: 2,
                                    padding: '10px',
                                    backgroundColor: '#e0e0e0',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: '#d0d0d0',
                                    },
                                }}
                                onClick={() => {
                                    setMessages([]); // Limpiar mensajes actuales
                                    handleChatClick(); // Ejecutar la función handleChatClick                                
                                }}
                            >
                                <Typography variant="body2">Nuevo Chat</Typography>
                            </Box>
                        </Box>
                    </motion.div>


                    <motion.div
                        initial="expanded"
                        animate={isExpanded ? "expanded" : "collapsed"}
                        variants={chatVariants}
                        transition={{ type: "tween", duration: 1 }}
                        style={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            borderRight: isExpanded ? 'none' : '1px solid rgba(0, 0, 0, 0.12)',
                            padding: 0,
                        }}
                    >
                        <Box sx={{ p: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: 1, borderColor: 'divider' }}>
                            <IconButton onClick={toggleHistoryMenu}>
                                <ViewHeadlineIcon />
                            </IconButton>
                            <Typography variant="h6">Chat {isExpanded ? 'Expanded' : 'Collapsed'}</Typography>
                            <Box sx={{ width: 24 }} />
                        </Box>

                        <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 4 }}>
                            <AnimatePresence>
                                {messages.map((message, index) => (
                                    <motion.div
                                        key={`${message.text}-${index}`} // Usa un ID único si existe, de lo contrario, combina el texto y el índice
                                        initial="initial"
                                        animate="animate"
                                        exit="exit"
                                        variants={messageVariants}
                                        transition={{ type: "spring", stiffness: 100, damping: 20, delay: index * 0.1 }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: message.sender === 'user' ? 'flex-end' : 'flex-start',
                                                mb: 1
                                            }}
                                        >
                                            <Paper
                                                elevation={0}
                                                sx={{
                                                    p: 1,
                                                    borderRadius: 4,
                                                    maxWidth: '90%',
                                                    bgcolor: message.sender === 'user' ? '#FFF9C4' : '#F8BBD0',
                                                }}
                                            >
                                                {renderMessageText(message.text)}
                                            </Paper>
                                        </Box>
                                    </motion.div>
                                ))}
                            </AnimatePresence>
                        </Box>


                        <Box sx={{ p: 1, bgcolor: '#FFF4C5', display: 'flex', alignItems: 'center', borderRadius: 25, m: 1 }}>
                            {isLoad && <React.Fragment>
                                <svg width={0} height={0}>
                                    <defs>
                                        <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                            <stop offset="0%" stopColor="#e01cd5" />
                                            <stop offset="100%" stopColor="#1CB5E0" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
                            </React.Fragment>}
                            <TextField
                                fullWidth
                                variant="standard"
                                placeholder="Envia un mensaje"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyPress={handleKeyPress}
                                multiline
                                maxRows={4}
                                InputProps={{
                                    disableUnderline: true,
                                    endAdornment: (
                                        <InputAdornment position="end">

                                            <IconButton size="small" component="label">
                                                <AttachFileIcon fontSize="small" />
                                                <input type="file" hidden onChange={handleUploadFile} />
                                            </IconButton>
                                            <IconButton size="small" onClick={handleSendMessage}>
                                                <SendIcon fontSize="small" />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />

                            {isMobile && (
                                <motion.div
                                    initial="initial"
                                    animate={isImageMovileOpen ? "activated" : "initial"}
                                    variants={isImageMovileVariants}
                                    transition={{ type: "tween", duration: 0.5 }}
                                    style={{
                                        position: 'fixed', // Para que permanezca en su posición al hacer scroll
                                        top: '85.5%', // Centrado verticalmente
                                        left: '50%', // Centrado horizontalmente
                                        transform: 'translate(-50%, -50%)', // Ajuste preciso para centrar en ambos ejes
                                    }}
                                >
                                    <Fab
                                        size="small"
                                        onClick={toggleImageMovileExpansion}
                                        sx={{
                                            bgcolor: '#FFF4C5',
                                            borderTopLeftRadius: '-50%',
                                            borderBottomRightRadius: '0%',
                                            borderBottomLeftRadius: '0%',
                                            boxShadow: 'none', // Comillas para evitar sombra

                                            '&:hover': {
                                                bgcolor: '#FFF4C5',
                                            },

                                        }}
                                    >
                                        <KeyboardArrowUpIcon />
                                    </Fab>
                                </motion.div>
                            )}
                        </Box>
                    </motion.div>

                    <AnimatePresence>
                        {isImageMovileOpen && isMobile && (
                            <motion.div
                                initial={{ opacity: 0, y: '309%', x: 0, }}
                                animate={{ opacity: 1, y: '209%', x: 0, }}
                                exit={{ opacity: 0, y: '309%', x: 0, }}
                                transition={{ type: "spring", stiffness: 100, damping: 20, mass: 1.5 }}
                                style={{
                                    width: '100%',
                                    height: '30%',
                                    position: 'absolute',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'linear-gradient(135deg, #FFB6C1, #FFA07A, #FFD700)',
                                    overflow: 'hidden',
                                }}
                            >
                                <motion.img
                                    src={image.character}
                                    alt="Cartoon character"
                                    initial={{ y: 100, opacity: 0 }}
                                    animate={{ y: 0, opacity: 1 }}
                                    transition={{ delay: 0.2, type: "spring", stiffness: 100, damping: 20 }}
                                    style={{
                                        width: 'auto',
                                        height: 'auto',
                                        position: 'absolute',
                                        bottom: '-20px',

                                    }}
                                />
                            </motion.div>
                        )}
                    </AnimatePresence>

                    <AnimatePresence>
                        {!isExpanded && !isMobile && (
                            <motion.div
                                initial={{ opacity: 0, x: 300, width: '20%', height: '100%' }}
                                animate={{ opacity: 1, x: 0, width: '60%', height: '100%' }}
                                exit={{ opacity: 0, x: 300, width: '20%', height: '100%' }}
                                transition={{ type: "spring", stiffness: 100, damping: 20, duration: 1.5 }}
                                className="absolute right-0 flex flex-col items-center justify-center w-3/5 h-full overflow-hidden"
                                style={{
                                    background: isSwitched ? '#222222' : 'linear-gradient(135deg, #FFB6C1, #FFA07A, #FFD700)',
                                }}
                            >
                                {!isSwitched ? (
                                    <>
                                        <motion.img
                                            src={image.character}
                                            alt="Cartoon character PC"
                                            initial={{ y: 100, opacity: 0 }}
                                            animate={{ y: 0, opacity: 1 }}
                                            transition={{ delay: 0.2, type: "spring", stiffness: 100, damping: 20 }}
                                            style={{
                                                width: 'auto',
                                                height: 'auto',
                                                position: 'absolute',
                                                bottom: '-20px',
                                                right: '10px',
                                            }}
                                        />
                                        <motion.div
                                            initial={{ opacity: 0, y: 50 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.5, type: "spring", stiffness: 100, damping: 20 }}
                                            className="absolute bottom-[260px] right-[280px] bg-white/80 p-4 rounded-[15px_15px_0_15px] shadow-md"
                                        >
                                            {/* Your ExpandingGrid component would go here */}
                                            <ExpandingGrid></ExpandingGrid>
                                        </motion.div>
                                    </>
                                ) : (
                                    <div className="flex items-center justify-center w-full h-full">
                                        <div className="text-2xl font-bold text-white">
                                            <LiteGraphComponent></LiteGraphComponent>
                                        </div>
                                    </div>
                                )}

                                <div className="absolute top-4 right-4 z-10">
                                    <Switch
                                        checked={isSwitched}
                                        onChange={handleSwitchChange}
                                        color="primary"
                                    />
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>

                    {!isMobile && (
                        <motion.div
                            initial="initial"
                            animate={isSideMenuOpen ? "activated" : "initial"}
                            variants={fabVariants}
                            transition={{ type: "tween", duration: 0.5 }}
                            style={{
                                position: 'absolute',
                                left: 0,
                                top: '50%',
                                borderTopRightRadius: '50%',
                                borderBottomRightRadius: '50%',
                                transform: 'translateY(-50%)',
                            }}
                        >
                            <SideMenuToggle isSideMenuOpen={isSideMenuOpen} toggleSideMenu={toggleSideMenu} />
                        </motion.div>
                    )}
                    {isMobile && (

                        <motion.div
                            initial="initial"
                            animate={isSideMenuOpen ? "activated" : "initial"}
                            variants={fabVariantsMovile}
                            transition={{ type: "tween", duration: 0.5 }}
                            style={{
                                position: 'fixed', // Para que permanezca en su posición al hacer scroll
                                top: '98%', // Centrado verticalmente
                                left: '50%', // Centrado horizontalmente
                                transform: 'translate(-50%, -50%)', // Ajuste preciso para centrar en ambos ejes
                            }}
                        >
                            <SideMenuToggleMovil isSideMenuOpen={isSideMenuOpen} toggleSideMenu={toggleSideMenu} />
                        </motion.div>

                    )}
                    <motion.div
                        initial={false}
                        transition={{ type: "spring", stiffness: 100, damping: 20, mass: 1.5 }}
                        style={{
                            position: 'absolute',
                            right: -40,
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                    >
                        {!isMobile && (
                            <Fab
                                size="small"
                                onClick={toggleChatExpansion}
                                sx={{
                                    borderTopRightRadius: '50%',
                                    borderBottomRightRadius: '50%',
                                    borderTopLeftRadius: 0,
                                    borderBottomLeftRadius: 0,
                                    bgcolor: 'white',
                                    '&:hover': {
                                        bgcolor: 'grey.200',
                                    },
                                }}
                            >
                                <ChevronRightIcon />
                            </Fab>
                        )}


                    </motion.div>
                </Container>
            </Box>
        </ThemeProvider>
    );
};
